import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { grantConsent, denyConsent } from "@/lib/gtag";

// Allow other components (cookies page) to reopen the banner.
export function reopenCookieBanner() {
  localStorage.removeItem("cookie-consent");
  window.dispatchEvent(new Event("open-cookie-banner"));
}

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("cookie-consent");
    if (saved === null) setVisible(true);
    else if (saved === "granted") grantConsent();
    const open = () => setVisible(true);
    window.addEventListener("open-cookie-banner", open);
    return () => window.removeEventListener("open-cookie-banner", open);
  }, []);

  const choose = useCallback((accepted) => {
    localStorage.setItem("cookie-consent", accepted ? "granted" : "denied");
    if (accepted) grantConsent();
    else denyConsent();
    setVisible(false);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Aviso de cookies"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 z-[100] mx-auto max-w-xl rounded-[14px] bg-brand-indigoDark p-6 text-[#E0E7FF] shadow-[0_16px_44px_rgba(31,41,55,0.4)]"
        >
          <p className="text-[13.5px] leading-relaxed">
            Usamos cookies de Google Ads para medir qué anuncios funcionan. Solo se activan
            si aceptas. Más información en la{" "}
            <Link to="/cookies" className="underline text-[#A5B4FC]">
              política de cookies
            </Link>
            .
          </p>
          <div className="mt-4 flex flex-wrap gap-2.5">
            <button
              data-testid="cookie-accept"
              onClick={() => choose(true)}
              className="rounded-[9px] bg-brand-mint px-5 py-2.5 text-[14px] font-medium text-[#04342C] hover:-translate-y-0.5 transition-transform duration-200"
            >
              Aceptar
            </button>
            <button
              data-testid="cookie-reject"
              onClick={() => choose(false)}
              className="rounded-[9px] border border-white/40 px-5 py-2.5 text-[14px] text-[#C7D2FE] hover:bg-white/5 transition-colors duration-200"
            >
              Rechazar
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
